import React, { useEffect, useState } from "react";

const LiveTimer = ({ initialTime, status, fontPercentage = 0 }) => {
  const [secondsLeft, setSecondsLeft] = useState(
    parseTimeToSeconds(initialTime)
  );
  const statusTextStyle = (color) => ({
    color: color,
    fontWeight: "600",
    fontSize: `${fontResize(14, fontPercentage)}px`,
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev + 1 : 0));
    }, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <span
      style={statusTextStyle(
        status === "overdelay"
          ? "#FF3B5F"
          : status === "ontime"
          ? "#40F7BE"
          : "#FFC01B"
      )}
    >
      {formatSecondsToTime(secondsLeft)}
    </span>
  );
};
const fontResize = (baseFont, percentage) => {
  const fontSize = baseFont * (1 + percentage / 100);
  return fontSize;
};
// Helpers outside component
const parseTimeToSeconds = (time) => {
  const [h, m, s] = time.split(":").map(Number);
  return h * 3600 + m * 60 + s;
};

const formatSecondsToTime = (totalSeconds) => {
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
    2,
    "0"
  );
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};

export default LiveTimer;
